/* eslint-disable  */
import { Button, Card, Col, Row } from "reactstrap";
import DataGrid from "../../components/dataGrid/DataGrid";
import moment from "moment";
import { useEffect, useReducer, useState } from "react";
import QueryString from "qs";
import { useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  exportExcelDispatchSummary,
  getDispatchSummaries,
} from "../../services/dispatchSummary.service";
import toast from "react-hot-toast";
import FormInput from "../../components/FormInput";
import FormSelect from "../../components/FormSelect";
import { getParties } from "../../services/parties.service";
import { getTransporters } from "../../services/transporters.service";
import { formatIndianAmount } from "../../utils/numberFormat";

const columns = [
  {
    selector: (row: any) => row.serialNumber,
    name: "S.No.",
    sortable: false,
    //   wrap: true,
    maxWidth: "70px",
    minWidth: "70px",
  },

  {
    selector: (row: any) => row.party?.code || "N/A",
    name: "Code",
    sortable: false,
  },
  {
    selector: (row: any) => row.party?.name || "N/A",
    name: "Party name",
    sortable: false,
  },
  {
    selector: (row: any) => row.transporter?.name || row.party?.transporter?.name || "N/A",
    name: "Transporter Name",
    sortable: false,
  },

  {
    selector: (row: any) => row.orderNumber,
    name: "Order Number",
    sortable: false,
  },
  {
    selector: (row: any) => moment(row.orderDate).format("DD-MM-YYYY"),
    name: "Order Date",
    sortable: false,
  },
  {
    selector: (row: any) => formatIndianAmount(row.orderAmount),
    name: "Order Amount",
    sortable: false,
  },

  {
    selector: (row: any) => row.invoiceNumber,
    name: "Invoice Number",
    sortable: false,
  },

  {
    selector: (row: any) => moment(row.invoiceDate).format("DD-MM-YYYY"),
    name: "Invoice Date",
    sortable: false,
  },

  {
    selector: (row: any) => formatIndianAmount(row.invoiceAmount),
    name: "Invoice Amount",
    sortable: false,
  },

  {
    selector: (row: any) => (row.mixItem ? `${row.numberOfBox} (Mixed)` : row.numberOfBox),
    name: "Number of Box",
    sortable: false,
  },

  {
    selector: (row: any) => moment(row.dispatch?.dispatchDate).format("DD-MM-YYYY"),
    name: " Dispatch Date",
    sortable: false,
  },

  {
    selector: (row: any) => row.dispatch.driverName,
    name: "Driver Name",
    sortable: false,
  },

  {
    selector: (row: any) => row.dispatch.vehicleNumber,
    name: "Vehicle Number",
    sortable: false,
  },
];

const initialState = {
  data: [],
  page: 1,
  limit: 100,
  totalPages: 1,
  totalResults: 0,
  startIndex: 1,
  endIndex: 100,
};

function reducer(state: any, action: any) {
  switch (action.type) {
    case "SET_DATA":
      return action.payload;
    default:
      return state;
  }
}

export default function DispatchSummary() {
  const [filterData, setFilterData] = useState({
    orderNumber: "",
    invoiceNumber: "",
    orderFrom: "",
    orderTo: "",
    party: "",
    transporter: "",
  });
  const [party, setParty] = useState("");
  const [transporter, setTransporter] = useState("");
  const [loading, setLoading] = useState(true);
  const [data, dispatch] = useReducer(reducer, initialState);
  const location = useLocation();
  const navigate = useNavigate();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });

  const setData = (data: any) => {
    dispatch({ type: "SET_DATA", payload: data });
  };

  const parseDateValue = (value: unknown) => {
    if (typeof value !== "string" || !value) {
      return null;
    }

    const parsedDate = new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  };

  useEffect(() => {
    const { page, orderNumber, invoiceNumber, orderFrom, orderTo, party, transporter } = query;
    setFilterData({
      orderNumber: typeof orderNumber === "string" ? orderNumber : "",
      invoiceNumber: typeof invoiceNumber === "string" ? invoiceNumber : "",
      orderFrom: typeof orderFrom === "string" ? orderFrom : "",
      orderTo: typeof orderTo === "string" ? orderTo : "",
      party: typeof party === "string" ? party : "",
      transporter: typeof transporter === "string" ? transporter : "",
    });

    setLoading(true);

    getDispatchSummaries({
      page,
      orderNumber,
      invoiceNumber,
      orderFrom,
      orderTo,
      party,
      transporter,
    })
      .then((response: any) => {
        setData(response.data);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  }, [location.search]);

  const handleFilter = () => {
    const queryParams: any = { ...query, page: 1, ...filterData };
    Object.keys(queryParams).forEach((key) => {
      if (!queryParams[key]) {
        delete queryParams[key];
      }
    });
    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}${Object.keys(queryParams).length > 0 ? "?" + queryString : ""}`);
  };

  const handleClearFilter = () => {
    setFilterData({
      orderNumber: "",
      invoiceNumber: "",
      orderFrom: "",
      orderTo: "",
      party: "",
      transporter: "",
    });
    setParty("");
    setTransporter("");
    const queryParams = { page: 1 };
    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}?${queryString}`);
  };

  return (
    <div className='d-flex flex-column h-100 px-sm-1 w-100 pb-sm-1'>
      <Row className='align-items-center mb-2 page-title-row'>
        <Col sm>
          <h1 className='my-1 fw-bold h4'>Dispatch Summary</h1>
        </Col>
      </Row>

      <div className='flex-grow-1 overflow-hidden' style={{ height: "calc(100vh - 230px)" }}>
        <Card className='h-100 p-3 w-100 '>
          <div className='d-flex flex-column h-100 rounded-0 list-data-grid-wrapper'>
            <DataGrid
              columns={columns}
              data={data}
              loading={loading}
              isFilterApplied={Object.keys(query).some((key) => key !== "page")}
              noDataTitle='No dispatch summaries found'
              noDataSubtitle='There are no dispatch summaries available right now.'
              noDataFilteredTitle='No dispatch summaries match your filters'
              noDataFilteredSubtitle='Try changing or clearing the filter criteria.'
              filterByDate={true}
              FilterSubHeader={true}
              filterData={filterData}
              setFilterData={setFilterData}
              subHeaderComponent={
                <Row className='w-100 align-items-start g-3 py-1 px-1'>
                  <Col md={2}>
                    <FormSelect
                      id='party'
                      name='party'
                      label='Party'
                      isAsync
                      isClearable
                      defaultFilter={{ status: true }}
                      getOptions={getParties}
                      onChange={(name: any, value: any) => {
                        setParty(value);
                        setFilterData({
                          ...filterData,
                          [name]: value?.id,
                        });
                      }}
                      getOptionLabel={(row: any) => `${row.name} (${row.code})`}
                      formatOptionLabel={(row: any, { context }: any) =>
                        context === "menu" ? (
                          <>
                            <small>{row.name}</small>
                            <div>({row.code})</div>
                          </>
                        ) : (
                          <span>
                            {row.name} ({row.code})
                          </span>
                        )
                      }
                      value={party}
                    />
                  </Col>
                  <Col md={2}>
                    <FormSelect
                      id='transporter'
                      name='transporter'
                      label='Transporter'
                      isAsync
                      isClearable
                      defaultFilter={{ status: true }}
                      getOptions={getTransporters}
                      onChange={(name: any, value: any) => {
                        setTransporter(value);
                        setFilterData({
                          ...filterData,
                          [name]: value?.id,
                          party: "",
                        });
                        setParty("");
                      }}
                      value={transporter}
                    />
                  </Col>
                  <Col md={2}>
                    <FormInput
                      name='orderNumber'
                      label='Order Number'
                      placeholder='Order Number'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData.orderNumber}
                    />
                  </Col>
                  <Col md={2}>
                    <FormInput
                      name='invoiceNumber'
                      label='Invoice Number'
                      placeholder='Invoice Number'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData.invoiceNumber}
                    />
                  </Col>
                  <Col md={2}>
                    <div
                      className='form-label'
                      style={{ fontSize: "0.875rem", fontWeight: 500, marginBottom: "0.375rem" }}
                    >
                      Date Range
                    </div>
                    <DatePicker
                      selectsRange
                      startDate={parseDateValue(filterData.orderFrom)}
                      endDate={parseDateValue(filterData.orderTo)}
                      onChange={(dates: [Date | null, Date | null]) => {
                        const [startDate, endDate] = dates;
                        setFilterData({
                          ...filterData,
                          orderFrom: startDate ? moment(startDate).format("YYYY-MM-DD") : "",
                          orderTo: endDate ? moment(endDate).format("YYYY-MM-DD") : "",
                        });
                      }}
                      isClearable
                      dateFormat='dd/MM/yyyy'
                      className='form-control'
                      placeholderText='Select date range'
                    />
                  </Col>
                  <Col md='auto'>
                    <div className='filter-action-buttons'>
                      <Button color='primary' size='sm' onClick={() => handleFilter()}>
                        Filter
                      </Button>
                      <Button color='danger' size='sm' onClick={() => handleClearFilter()}>
                        Clear
                      </Button>
                    </div>
                  </Col>
                  <Col className='ms-auto' md='auto'>
                    <div className='filter-export-button'>
                      <Button
                        color='primary'
                        size='sm'
                        onClick={() => {
                          const { orderNumber, invoiceNumber, orderFrom, orderTo, party, transporter } =
                            query;
                          exportExcelDispatchSummary({
                            orderNumber,
                            invoiceNumber,
                            orderFrom,
                            orderTo,
                            party,
                            transporter,
                          })
                            .then((response) => {
                              const blobURL = URL.createObjectURL(response.data);
                              const anchor = document.createElement("a");
                              anchor.href = blobURL;
                              anchor.download = "Dispatch Summary.xlsx";
                              anchor.click();
                              URL.revokeObjectURL(blobURL);
                            })
                            .catch(() => {
                              toast.error("Record not found to export.");
                            });
                        }}
                      >
                        Export
                      </Button>
                    </div>
                  </Col>
                </Row>
              }
            />
          </div>
        </Card>
      </div>
    </div>
  );
}
